<template>
  <div class="usermanagement">
    <h2 class="usermanagement-header fadein">Benutzermanagement</h2>
    <div class="usermanagement-subtitle fadein d100ms">
      Erstelle, verwalte und lösche Benutzerkonten
    </div>
    <CreateUserDialog :active="dialogOpen"></CreateUserDialog>
    <div class="usermanagement-card fadein d200ms">
      <TabView>
        <TabPanel header="Benutzer">
          <div>
            <DataTable
              @row-select="updateSelection"
              @row-unselect="updateSelection"
              selectionMode="single"
              :metaKeySelection="false"
              v-model:selection="selectedUser"
              :rowsPerPageOptions="[10, 25, 50, 100, 200]"
              :rows="10"
              paginator
              :loading="loading"
              v-model:filters="filters"
              :value="users"
              dataKey="uid"
            >
              <template #empty> Es wurden keine Benutzer gefunden. </template>
              <template #loading
                ><ProgressSpinner
                  stroke="white"
                  stroke-width="6"
                  style="width: 3rem; height: 3rem"
                ></ProgressSpinner
              ></template>
              <Column header="Benutzername" field="displayname">
                <template #body="slotProps">
                  <div style="display: flex; gap: 0.5rem; flex-wrap: wrap">
                    <b>{{ slotProps.data.displayname }}</b>
                    <Tag
                      v-if="slotProps.data.deactivated"
                      severity="danger"
                      value="Deaktiviert"
                      style="font-weight: 900"
                    ></Tag>
                  </div>
                </template>
              </Column>
              <Column header="Benutzergruppen" field="groups" style="max-width: 20rem">
                <template #body="slotProps">
                  <div style="display: flex; gap: 0.3rem; flex-wrap: wrap">
                    <Tag v-for="group in slotProps.data.groups" :value="group"></Tag>
                    <Tag
                      v-if="slotProps.data.groups.length == 0"
                      severity="warning"
                      value="Keine Gruppen"
                    ></Tag>
                  </div>
                </template>
              </Column>
              <Column header="Benutzer UUID" field="uid">
                <template #body="slotProps">
                  <code>{{ slotProps.data.uid }}</code>
                </template>
              </Column>
              <Column header="Aktionen">
                <template #body="slotProps">
                  <div style="display: flex; gap: 0.3rem">
                    <!--<Button severity="secondary" text outlined icon="fa-regular fa-edit" label="Bearbeiten"></Button>-->
                    <Button
                      severity="danger"
                      @click="deleteConfirmation($event, slotProps.data.uid)"
                      :disabled="
                        !authStore.hasUserPermission('management.users.delete') ||
                        loading ||
                        authStore.weight <= slotProps.data.weight ||
                        selectedUser == null
                      "
                      text
                      outlined
                      icon="fa-regular fa-trash"
                      label="Löschen"
                    ></Button>
                    <Button
                      severity="warning"
                      @click="resetPassword($event, slotProps.data.uid)"
                      :disabled="
                        !authStore.hasUserPermission('management.users.resetpassword') ||
                        loading ||
                        authStore.weight <= slotProps.data.weight ||
                        selectedUser == null
                      "
                      text
                      outlined
                      icon="fa-regular fa-key"
                      label="Passwort zurücksetzen"
                    ></Button>
                    <ConfirmPopup style="max-width: 25rem"></ConfirmPopup>
                  </div>
                </template>
              </Column>
            </DataTable>

            <Button
              style="margin-top: 1rem"
              @click="dialogOpen = true"
              :disabled="!authStore.hasUserPermission('management.users.create')"
              outlined
              text
              label="Benutzer Erstellen"
              severity="success"
              icon="fa-solid fa-plus"
            ></Button>
          </div>
        </TabPanel>

        <TabPanel header="Informationen" :disabled="selectedUser == null">
          <UserInformations :selected-user="selectedUser" ></UserInformations>
        </TabPanel>
        <!-- <TabPanel header="Authentifizierung" :disabled="hidePanels" :visible="false">
          <p>Die Authentifizierung des Benutzers Kommt Bald.</p>
        </TabPanel> -->
        <TabPanel header="Benutzergruppen" :disabled="selectedUser == null">
          <UserGroups :selected-user="selectedUser"></UserGroups>
        </TabPanel>
      </TabView>
    </div>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ColumnGroup from 'primevue/columngroup'
import Row from 'primevue/row' 
import IconField from 'primevue/iconfield'
import InputIcon from 'primevue/inputicon'
import InputText from 'primevue/inputtext'
import TabView from 'primevue/tabview'
import Button from 'primevue/button'
import TabPanel from 'primevue/tabpanel'
import { FilterMatchMode } from 'primevue/api'
import axios from 'axios'
import { getAuth, sendPasswordResetEmail, sendEmailVerification } from 'firebase/auth'
import SelectButton from 'primevue/selectbutton'
import { config } from '../../assets/config.js'
import ConfirmPopup from 'primevue/confirmpopup'
import Tag from 'primevue/tag'
import { useAuthStore } from '@/stores/auth.js'
import CreateUserDialog from '@/components/CreateUserDialog.vue'
import ProgressSpinner from 'primevue/progressspinner'
import UserInformations from '../../components/UserInformations.vue'
import UserGroups from '@/components/UserGroups.vue'


export default {
  components: {
    DataTable,
    Column,
    ColumnGroup,
    Row,
    IconField,
    InputIcon,
    InputText,
    SelectButton,
    TabView,
    TabPanel,
    Tag,
    Button,
    CreateUserDialog,
    ConfirmPopup,
    ProgressSpinner,
    UserInformations,
    UserGroups
  },

  data() {
    return {
      authStore: useAuthStore(),
      auth: getAuth(),
      dialogOpen: false,
      selectedUser: null,
      users: [],
      loading: true,
      hidePanels: true
    }
  },

  methods: {
    async updateUsersAndSelectedUser() {
      await this.fetchData()
      this.selectedUser = this.users.find((user) => user.uid == this.selectedUser.uid)
    },
    updateSelection() {
      this.hidePanels =
        this.selectedUser == null || this.selectedUser.weight >= useAuthStore().weight
    },
    deleteConfirmation(event, userid) {
      this.$confirm.require({
        target: event.currentTarget,
        message: 'Bist du dir sicher, dass du diesen Benutzer entgültig löschen möchtest?',
        icon: 'fa-solid fa-warning',
        acceptIcon: 'fa-solid fa-trash',
        acceptLabel: 'Löschen',
        acceptClass: 'p-button-danger p-button-outlined p-button-sm',
        rejectClass: 'p-button-secondary p-button-outlined p-button-sm',
        rejectLabel: 'Abbrechen',
        rejectIcon: 'fa-solid fa-xmark',

        accept: () => {
          this.startUserDeletion(userid)
        }
      })
    },
      resetPassword(event, userid) {
        sendPasswordResetEmail(this.auth, this.selectedUser.email).then(() => {
          this.$toast.add({
          severity: 'success',
          summary: 'Passwort Rücksetzungsanfrage gesendet',
          group: 'tc',
          detail: 'Die Zurücksetzungsanfrage wurde an Den Administrator gesendet.',
          life: 5000
        })
        }).catch((error) => {
          this.$toast.add({
          severity: 'error',
          summary: 'Passwort Rücksetzungsanfrage fehlgeschlagen',
          group: 'tc',
          detail: 'Fehler: ' + error.status,
          life: 5000
        })
        })
      },
    async startUserDeletion(userid) {
      if (this.selectedUser && this.selectedUser.uid == userid) this.selectedUser = null
      this.loading = true

      let response = await axios.post(
        config.api_url + '/api/management/users/delete',
        {
          uid: userid
        },
        {
          headers: {
            Authorization: await getAuth().currentUser.getIdToken()
          }
        }
      )

      this.fetchData()
    },
    async fetchData() {
      let response = await axios.get(config.api_url + '/api/management/users', {
        headers: {
          Authorization: await getAuth().currentUser.getIdToken()
        }
      })

      if (response.status != 200) return

      this.users = response.data
      this.loading = false
    }
  },

  async mounted() {
    await this.fetchData()
  }
}
</script>
<style lang="scss" scoped>
.usermanagement {
  &-header {
    margin-bottom: 0;
  }

  &-subtitle {
    color: rgb(192, 192, 192);
  }

  &-card {
    margin-top: 2rem;
    border-radius: 1rem;
    padding: 1rem;
    background-color: var(--surface-0);
  }
}

.p-progress-spinner-circle {
  stroke-dasharray: 89, 200;
  stroke-dashoffset: 0;
  stroke: #ccc;
  animation: p-progress-spinner-dash 1.5s ease-in-out infinite;
  stroke-linecap: round;
}
</style>
